import axios from 'axios'

class ProviderService {
  constructor() {
    this.baseUrl = '/api/v1/provider/'
  }

  getProviderList(data) {
    return axios
      .post(`${this.baseUrl}get_provider_list/`, data)
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response.status === 400 && error.response.data) {
          return error.response.data
        }
      })
  }

  getProviderDetails(data) {
    return axios
      .post(`${this.baseUrl}get_provider_detail/`, data)
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response.status === 400 && error.response.data) {
          return error.response.data
        }
      })
  }
}

export const providerService = new ProviderService()
